import { Controller } from "react-hook-form";
import { Stack, Group, Divider } from "@mantine/core";
import useIsDesktop from "../../../../hooks/useIsDesktop";
import { CustomSwitch } from "../../../ui/CustomSwitch/CustomSwitch";
import CustomModal from "../../../ui/CustomModal/CustomModal";
import CustomTextInput from "../../../ui/CustomTextInput/CustomTextInput";
import CustomSelect from "../../../ui/CustomSelect/CustomSelect";
import CustomButton from "../../../ui/CustomButton/CustomButton";
import { validationSchemas } from "../hooks/useAccountForm";
import { optionsFilterByLabel } from "../../../../utils/optionsFilter";

const { msisdn: msisdnValidator, provider: providerValidator } =
  validationSchemas.mobileMoneyValidators;

const AddMobileMoneyModal = ({
  opened,
  onClose,
  onSubmit,
  control,
  isSubmitting,
}) => {
  const isDesktop = useIsDesktop();
  const labelStyle = {
    label: {
      fontWeight: 600,
      color: "#1f2937",
      fontSize: "0.9rem",
      marginBottom: "4px",
    },
  };

  return (
    <CustomModal
      opened={opened}
      onClose={onClose}
      title={
        <span className="text-lg font-semibold text-gray-900">
          Add Mobile Money Account
        </span>
      }
      centered
      radius="lg"
      overlayProps={{ backgroundOpacity: 0.55, blur: 3 }}
      styles={{ body: { padding: 0 } }}
      closeOnEscape={!isSubmitting}
      closeOnClickOutside={!isSubmitting}
      withCloseButton={!isSubmitting}
    >
      <div
        style={{
          maxHeight: "calc(90dvh - 170px)",
          overflowY: "auto",
          padding: "0 1rem 1rem",
        }}
      >
        <Divider mb="md" />
        <form onSubmit={onSubmit}>
          <Stack>
            <Controller
              name="msisdn"
              control={control}
              rules={{ validate: (v) => msisdnValidator(v) ?? true }}
              render={({ field, fieldState }) => (
                <CustomTextInput
                  label="MSISDN (Phone Number)"
                  placeholder="e.g. 254712345678"
                  radius="xl"
                  styles={labelStyle}
                  disabled={isSubmitting}
                  withAsterisk
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                  error={fieldState.error?.message}
                />
              )}
            />

            <Controller
              name="provider"
              control={control}
              rules={{ validate: (v) => providerValidator(v) ?? true }}
              render={({ field, fieldState }) => (
                <CustomSelect
                  label="Provider"
                  placeholder="Select provider"
                  data={["Safaricom"]}
                  value={field.value}
                  onChange={field.onChange}
                  error={fieldState.error?.message}
                  radius="xl"
                  styles={labelStyle}
                  disabled={isSubmitting}
                  withAsterisk
                  comboboxProps={{ withinPortal: false }}
                  filter={optionsFilterByLabel}
                />
              )}
            />

            <Controller
              name="accountName"
              control={control}
              render={({ field }) => (
                <CustomTextInput
                  label="Account Name"
                  placeholder="Enter account name"
                  radius="xl"
                  styles={labelStyle}
                  disabled={isSubmitting}
                  value={field.value}
                  onChange={field.onChange}
                  onBlur={field.onBlur}
                />
              )}
            />

            <Controller
              name="isDefaultPayout"
              control={control}
              render={({ field }) => (
                <CustomSwitch
                  checked={field.value || false}
                  onChange={(e) => field.onChange(e.currentTarget.checked)}
                  activeLabel="IsDefaultPaymentMethod"
                  color="primary"
                  inactiveLabel="NotDefaultPaymentMethod"
                  disabled={isSubmitting}
                />
              )}
            />

            <Group
              justify={isDesktop ? "flex-end" : "stretch"}
              grow={!isDesktop}
              mt="md"
            >
              <CustomButton
                variant="default"
                onClick={onClose}
                disabled={isSubmitting}
              >
                Cancel
              </CustomButton>
              <CustomButton
                type="submit"
                disabled={isSubmitting}
                loading={isSubmitting}
              >
                Add Mobile Money Account
              </CustomButton>
            </Group>
          </Stack>
        </form>
      </div>
    </CustomModal>
  );
};

export default AddMobileMoneyModal;
